export default "__VITE_ASSET__DEmgtsyI__"